import { Alert, LinearProgress } from '@mui/material'

import { ErrorBoundary } from 'react-error-boundary'
import { ErrorScreen, InterfaceContent } from '~/shared/ui'
import { Navigate } from 'react-router'
import { useCase } from '~/entities/case'
const CaseDetail = ({ id }: { id: number }) => {
  const { data, isPending: isLoading, error } = useCase(id)

  if (data?.person) {
    return <Navigate to={`/people/${data.person}/todos?caseId=${id}`} replace />
  }

  return (
    <InterfaceContent>
      {isLoading && !error ? <LinearProgress /> : null}
      <ErrorBoundary FallbackComponent={ErrorScreen}>
        {error ? <Alert severity="info">Could not locate case with ID {id}</Alert> : null}
      </ErrorBoundary>
    </InterfaceContent>
  )
}

export default CaseDetail
